if (!customElements.get('cos-announcement-bar')) {
  customElements.define('cos-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.cos-announcement-section');
      this.messageGroups = Array.from(this.querySelectorAll('.cos-announcement-group')).map((group) => ({
        group,
        originals: Array.from(group.children)
      }));
      this.fillTrack = () => {
        if (!this.classList.contains('cos-announcement--scroll')) return;
        const viewportWidth = this.clientWidth;
        if (this.lastViewportWidth === viewportWidth) return;
        this.lastViewportWidth = viewportWidth;
        this.messageGroups.forEach(({ group, originals }) => {
          Array.from(group.children).forEach((child) => {
            if (!originals.includes(child)) child.remove();
          });
        });
        const groupWidth = this.messageGroups[0]?.group.getBoundingClientRect().width || 0;
        if (!groupWidth) return;
        const repeats = Math.ceil(viewportWidth / groupWidth);
        this.messageGroups.forEach(({ group, originals }) => {
          for (let repeat = 1; repeat < repeats; repeat++) {
            originals.forEach((original) => {
              const copy = original.cloneNode(true);
              copy.removeAttribute('data-shopify-editor-block');
              copy.removeAttribute('data-shopify-editor-block-id');
              copy.setAttribute('aria-hidden', 'true');
              copy.setAttribute('inert', '');
              group.append(copy);
            });
          }
        });
      };
      this.reserveSpace = () => {
        this.fillTrack();
        const height = `${this.getBoundingClientRect().height}px`;
        if (this.section) this.section.style.height = height;
        document.documentElement.style.setProperty('--cos-announcement-height', height);
      };
      this.resizeObserver = new ResizeObserver(this.reserveSpace);
      this.resizeObserver.observe(this);
      this.reserveSpace();
      this.onFontsLoaded = () => {
        if (!this.isConnected) return;
        this.lastViewportWidth = null;
        this.reserveSpace();
      };
      document.fonts?.ready.then(this.onFontsLoaded);
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.section) this.section.style.removeProperty('height');
      document.documentElement.style.removeProperty('--cos-announcement-height');
    }
  });
}
